<div class="silence-alert">
  <div class="headline">Silence!</div>
  <div class="headline-2">
    <span class="w2">沈黙</span><br />
    <span class="w1">silencio</span>
    <span class="w3">schweigen</span><br />
    <span class="w4">tystnad!</span>
  </div>
</div>
